import * as React from 'react';
import { DEFAULT_SIZE, DEFAULT_COLOR } from '../types';
import { Child, StyledDoubleBounce } from './styles';
const DoubleBounce = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, className, }) => {
    return (React.createElement(StyledDoubleBounce, { className: className, size: size, color: color },
        React.createElement(Child, null),
        React.createElement(Child, { isDelay: true })));
};
export default DoubleBounce;
//# sourceMappingURL=index.js.map